export default __webpack_public_path__ + "static/icon-24-6-b2c5c4a9329326bec2c8f04218230bd6.png";